export const environment = {
  production: true,

  API_URL: 'https://portal-api.golmn.com/v1/',
  API_TOKEN_URL: 'https://portal-api.golmn.com/token',
  AZURE_API_URL: 'https://app-lmn-internal-prod-internal.golmn.com/api/v1',
  PAYMENTS_FUNCTION_API_URL: 'https://func-lmn-payments-prod.azurewebsites.net/api/',
  GOOGLE_API_KEY: 'AIzaSyAHxIqABLc5b5q_FI4Fpa6ogQZRuRhmpJY',
  CARD_CONNECT_URL: 'https://fts.cardconnect.com/',
  SEJDA_PUBLISHABLE_KEY: 'api_public_fac4b4c1e04a4b7b9c8ff8f1fd8fd77d',
  GA_MEASUREMENT_ID: 'UA-104198365-10',

  PAYRIX_API_KEY: '0e21f956b68d17fb16010e9617388767',
  PAYRIX_PAYFRAME: 'https://api.payrix.com/payFrameScript',
  PAYRIX_PAYFIELDS: 'https://api.payrix.com/payFieldsScript',
  PAYRIX_URL: 'https://api.payrix.com/',
  LAUNCH_DARKLY_CLIENT_ID: '67619555ff094e0b7a0767b9',
  PENDO_KEY: 'b6aced95-30ba-4c88-609f-cdfdb28116a4',

  STRIPE_PUBLISHABLE_KEY_USD:
    'pk_live_51RrOy25gCoaShzZlMuVyns46KGC9z0nbelMDS71XgIky2BKyM5LyE7C9nTWvcLgOUYwJuaZqwglPlrdXao4h9kiX00EjUQ19eJ',
  STRIPE_PUBLISHABLE_KEY_CAD:
    'pk_live_51Rw5LeEgQt4bxgFcEz3t7bn97ra1jth4JcyWhjDsrnQEVHXCvgryjxUQFciS24Z6pfQsNLU6kysic2mVl1qwUIsz00wJIfq3PJ',

  DATA_DOG_ID: 'pub35eecc3995587f614d19164371d3fbea',
  DATA_DOG_ENV: 'production',
   DATA_DOG_VERSION: '25006074872',
};
